<script lang="ts" setup>
import { LoaderOverlay } from '@UI/Loaders/LoaderOverlay'

defineOptions({
  name: 'SkeletonProgressReports',
})

</script>

<template>
  <div class="progress-reports skeleton">
    <LoaderOverlay />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Sections/ProgressReports/SectionProgressReports.scss" />
